import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Journey } from './analysisApi';
import MessagesSidebar from './MessagesSidebar';
import JourneyView from './JourneyView';
import Topbar from '../Topbar';

const MessagesPage: React.FC = () => {
  const [selectedJourney, setSelectedJourney] = useState<Journey | null>(null);

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      backgroundColor: '#111e2d',
      fontFamily: '"IBM Plex Sans", sans-serif',
    }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');`}</style>

      {/* Shared topbar */}
      <Topbar menuState={false} openAction={() => {}} />

      {/* Page title bar */}
      <Box sx={{
        mt: '64px',                 // below fixed AppBar
        px: 3, py: 1.5,
        backgroundColor: '#0a1520',
        borderBottom: '1px solid rgba(240,165,0,0.15)',
        display: 'flex', alignItems: 'center', gap: 2,
      }}>
        <Typography sx={{
          fontFamily: '"IBM Plex Mono"',
          fontSize: '11px',
          letterSpacing: '0.15em',
          color: '#f0a500',
          textTransform: 'uppercase',
        }}>
          Analyse
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.2)', fontSize: '11px' }}>
          /
        </Typography>
        <Typography sx={{
          fontFamily: '"IBM Plex Mono"',
          fontSize: '11px',
          letterSpacing: '0.1em',
          color: 'rgba(255,255,255,0.5)',
          textTransform: 'uppercase',
        }}>
          Fehlende Meldungen
        </Typography>
      </Box>

      {/* Main content */}
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <MessagesSidebar
          selectedJourneyId={selectedJourney?.journey_id ?? null}
          onSelectJourney={setSelectedJourney}
        />

        {/* Main panel */}
        {selectedJourney ? (
          <JourneyView journey={selectedJourney} />
        ) : (
          <Box sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#111e2d',
          }}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{
                fontFamily: '"IBM Plex Mono"',
                fontSize: '11px',
                letterSpacing: '0.15em',
                color: 'rgba(255,255,255,0.2)',
                textTransform: 'uppercase',
                mb: 1,
              }}>
                Zug auswählen
              </Typography>
              <Typography sx={{
                fontFamily: '"IBM Plex Sans"',
                fontSize: '13px',
                color: 'rgba(255,255,255,0.15)',
              }}>
                Select a journey from the sidebar to view stop details
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default MessagesPage;
